import Modal from 'components/Modal';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import CheckGiftCardV2, { useCheckGiftCardV2Ref } from './CheckGiftCard';
import { Form } from 'antd';
type Ref = {
  open: () => void;
};
export const useModalCheckGiftCardRef = () => useRef<Ref>(null);
const ModalCheckGiftCard = forwardRef<Ref>((_, ref) => {
  const [formCheck] = Form.useForm();
  const [visible, setOpen] = useState(false);
  const giftRef = useCheckGiftCardV2Ref();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  useImperativeHandle(ref, () => ({ open: handleOpen }));
  return (
    <Modal
      visible={visible}
      onClose={handleClose}
      width={'auto'} footer={null} className='modal-overflow-unset modal-non-opacity'
      hiddenHeader
      noneBodyStyle
      okTitle='Issue'
    >
      <CheckGiftCardV2
        ref={giftRef}
        form={formCheck}
        onClose={handleClose}
        onlyCheck
      />
    </Modal>
  );
});
ModalCheckGiftCard.displayName = 'ModalCheckGiftCard';
export default ModalCheckGiftCard;
